import { render, staticRenderFns } from "./AdminCohortGrid.vue?vue&type=template&id=f0b99dfa&scoped=true"
import script from "./AdminCohortGrid.vue?vue&type=script&lang=js"
export * from "./AdminCohortGrid.vue?vue&type=script&lang=js"
import style0 from "./AdminCohortGrid.vue?vue&type=style&index=0&id=f0b99dfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0b99dfa",
  null
  
)

export default component.exports